<nb-layout>
  <nb-layout-header fixed>
    <app-header></app-header>
  </nb-layout-header>

  <!-- <nb-sidebar></nb-sidebar> -->

  <nb-layout-column style="padding: 0;">
    <router-outlet></router-outlet>
  </nb-layout-column>
</nb-layout>